export const guestLoanSelector = (state) => {
  if (state.orm && state.orm.GuestLoans && state.orm.GuestLoans.itemsById) {
    return Object.values(state.orm.GuestLoans.itemsById);
  }
  if (state.GuestLoans && Array.isArray(state.GuestLoans)) {
    return state.GuestLoans;
  }
  return [];
};

export const selectGuestLoanByNumber = (state, loanNumber) => {
  const loans = guestLoanSelector(state);

  return loans.find((loan) => String(loan.number) === String(loanNumber));
};

export const selectGuestLoanHistoryTransactions = (state, loanNumber) => {
  const loan = selectGuestLoanByNumber(state, loanNumber);
  return loan?.historyTransactions || [];
};

export const selectGuestLoanScheduledTransactions = (state, loanNumber) => {
  const loan = selectGuestLoanByNumber(state, loanNumber);
  return loan?.scheduledTransactions || [];
};
